import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/controller/HomeCtrl.js';
import { sanitizeInput } from '@app/utils/sanitize';
import { flowMap } from '@app/service/OrderFormService';

function LtLifetouchCodeGuestLoginCtrl(
  $rootScope,
  $scope,
  $filter,
  $routeParams,
  $window,
  RouterService,
  ShoppingCartStore,
  OrderFormService,
  ContentStore,
  JobCleanUpService,
  JobStore,
  BlockService,
  AnalyticsService,
  AddNewStudentFormSubmissionService,
  PortraitIdFormatterService
) {
  this.lifetouchCode = sanitizeInput($routeParams.identifier, '') || '';
  this.portraitId = sanitizeInput($routeParams.identifier, '') || '';
  this.pictureDayId = sanitizeInput($routeParams.identifier, '') || '';
  this.accessCode = $routeParams.accessCode;
  this.email = sanitizeInput($routeParams.email, '') || '';
  this.lifetouchCodeFlow = '';
  this.lifetouchCodeInvalid = false;
  this.validatingCode = false;

  this.init = function () {
    if (!!this.pictureDayId && !!this.email) {
      return;
    } else if (this.pictureDayId && (OrderFormService.currentFlow === flowMap.SIGN_IN || !this.accessCode)) {
      RouterService.smartUrlTriggered = true;
      this.onContinue();
    }
  };

  this.backToSignIn = function () {
    $scope.backToSignIn();
  };

  this.onContinue = function () {
    if (this.lifetouchCode.length === 8) {
      this.lifetouchCode = this.lifetouchCode.replace(/^([a-zA-Z0-9]{4})[- ]?([a-zA-Z0-9]{4}).*/, '$1-$2');
    }
    $scope.lifetouchCode = this.lifetouchCode;
    $scope.portraitId = this.portraitId;
    $scope.pictureDayId = this.pictureDayId;

    if ($scope.lifetouchCodeLoginForm) {
      $scope.lifetouchCodeLoginForm.lifetouchCode.$setDirty();
      $scope.lifetouchCodeLoginForm.lifetouchCode.$setTouched();
      $scope.lifetouchCodeLoginForm.lifetouchCode.$validate();
    }

    if (!JobCleanUpService.cleanUpAndCanAddMoreJobs()) {
      return;
    }

    if (!this.isLifetouchCodeValid()) {
      if ($window.optimizeprepic) $scope.$broadcast('jobLoadFlagUpdated', true);
      AnalyticsService.addAdobeFormErrorEvent(
        AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_CODE,
        AnalyticsService.ADOBE_ERROR_DESCRIPTIONS.INVALID_INVALID_LT_CODE
      );
      return;
    }

    const formData = {};
    if (this.isPortraitIdEntered()) {
      AnalyticsService.addAdobeFormLoadEvent(AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_PORTRAITID_DETAIL);
      OrderFormService.changeFlowToPortraitId();
    } else {
      formData.pictureDayId = this.lifetouchCode;
      if ($window.optimizeprepic) {
        const accessedViaSmartLink = RouterService.isPictureDaySmartUrl();
        this.validatingCode = true;
        AddNewStudentFormSubmissionService.loadJobForAddStudentForm(formData, false, accessedViaSmartLink).finally(
          () => {
            this.validatingCode = false;
          }
        );
      } else {
        const options = { preventUpdatingJobData: true };
        JobStore.loadJob(formData, false, false, null, options).finally(function () {
          BlockService.unblockUI();
        });
        OrderFormService.changeFlowToPictureDayId();
      }
    }
  };

  this.validateInput = function (formControl) {
    if (formControl.$name === 'lifetouchCode') {
      this.lifetouchCodeInvalid = !this.isLifetouchCodeValid();
      if (!this.lifetouchCodeInvalid) {
        AnalyticsService.addAdobeFormErrorEvent(
          AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_CODE,
          AnalyticsService.ADOBE_ERROR_DESCRIPTIONS.INVALID_INVALID_LT_CODE
        );
      }
    }
  };

  this.onChangeLifetouchCodeHyphenCheck = () => {
    const input = this.lifetouchCode?.toUpperCase() || '';

    this.lifetouchCode = PortraitIdFormatterService.format(input);
  };

  this.isLifetouchCodeValid = function () {
    return (
      this.isPortraitId(this.formatInputTextFields(this.lifetouchCode)) ||
      this.isPictureDayId(this.formatInputTextFields(this.lifetouchCode))
    );
  };

  this.formatInputTextFields = function (text) {
    return (text && text.trim().toUpperCase()) || '';
  };

  this.isPortraitIdEntered = function () {
    if (!!this.lifetouchCode && this.isPortraitId(this.lifetouchCode)) {
      this.portraitId = this.lifetouchCode;
      return true;
    } else {
      this.pictureDayId = this.lifetouchCode;
      return false;
    }
  };

  this.isLifetouchCodeFlow = function () {
    return OrderFormService.getCurrentFlow().includes('activeLTCodeTab');
  };

  this.isPortraitIdFlow = function () {
    return OrderFormService.getCurrentFlow().includes('portraitIdForm');
  };

  this.isPictureDayIdFlow = function () {
    return OrderFormService.getCurrentFlow().includes('pictureDayIdForm');
  };

  this.getPortraitId = function () {
    var lc = this.getLifetouchCode();
    if (lc.length > 1 && this.isPortraitId(lc)) {
      return lc;
    }
  };

  this.getPictureDayId = function () {
    var lc = this.getLifetouchCode();
    if (lc.length > 1 && this.isPictureDayId(lc)) {
      return lc;
    }
  };

  this.isPortraitId = (lc) => PortraitIdFormatterService.isFormattedPortraitId(lc);

  this.isPictureDayId = (lc) => {
    if (!this.isPortraitId(lc)) {
      const isEV = PortraitIdFormatterService.isEV(lc);
      if ((isEV && lc.length === 9) || lc.length === 10) {
        return true;
      }
    }
    return false;
  };

  this.getLifetouchCode = function () {
    return this.lifetouchCode;
  };

  this.getPopoverForLifetouchCode = function () {
    const portraitIdText = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PORTRAIT_ID_TEXT')
    );
    const portraitIdImage = ContentStore.getContentImageUrl(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PORTRAIT_ID_IMAGE')
    );
    const portraitIdAlt = ContentStore.getContent('MOBILE_TRANS_HOME', 'POPOVER_PORTRAIT_ID_IMAGE_ALT');

    this.preloadedImage = this.preloadedImage || new Image();
    this.preloadedImage.src = portraitIdImage;

    return (
      '' +
      '<div class="digital-info-popover">' +
      '   <p class="f5 mara-dark-grey text-center top-24">' +
      portraitIdText +
      '</p>' +
      '   <div class="preloaded-image-container"><img height="119px" width="320px" src="' +
      portraitIdImage +
      '" alt="' +
      portraitIdAlt +
      '"/></div>' +
      '</div>'
    );
  };

  this.isContinueDisabled = () => this.isValidatingCode();

  this.isCodeInputDisabled = () => this.isValidatingCode();

  this.isValidatingCode = () => Boolean($window.optimizeprepic) && this.validatingCode;

  this.getContinueButtonLabel = () => {
    const key = this.isValidatingCode() ? 'VALIDATING_YOUR_CODE' : 'LIFETOUCH_CODE_CONTINUE_BUTTON';

    return $filter('ltTranslateFilter')(key);
  };

  this.onChangeAction = () => {
    $scope.jobLoadFailed = false;
  };
}

App.controller('LtLifetouchCodeGuestLoginCtrl', [
  '$rootScope',
  '$scope',
  '$filter',
  '$routeParams',
  '$window',
  'RouterService',
  'ShoppingCartStore',
  'OrderFormService',
  'ContentStore',
  'JobCleanUpService',
  'JobStore',
  'BlockService',
  'AnalyticsService',
  'AddNewStudentFormSubmissionService',
  'PortraitIdFormatterService',
  LtLifetouchCodeGuestLoginCtrl
]);
